export { default } from './VerificationRegistrationMerchant';
